export default __webpack_public_path__ + "static/media/p45.19ddd944.jpg";